<template>
  <BaseBlock title="Mot de passe oublié">
    <v-form v-model="valid" ref="form">
      <BaseAlert :error="error" />
      <div v-if="ifWaitSend">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="formulaire.email"
              label="Adresse mail de login"
              :rules="mailRules"
              @input="resetApiErrors('email')"
              :error-messages="checkApiErrors('email')"
              outlined
              shaped
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="text-center">
              <v-btn
                class="mx-2"
                color="primary"
                @click="envoiMail"
                :disabled="!valid"
                >Envoyer mail</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        Un mail de réinitialisation de mot de passe vous a été envoyé.
      </div>
    </v-form>
  </BaseBlock>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiGestionCompte from "@/repositories/ApiGestionCompte";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "OubliMDP",
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  data() {
    return {
      formulaire: {
        email: "",
        mdp: "",
      },
      message: null,
      ifWaitSend: true,
      mailRules: [
        (v) =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail doit être valide",
      ],
    };
  },
  methods: {
    async envoiMail() {
      try {
        await ApiGestionCompte.getMDP(this.formulaire);
        this.ifWaitSend = false;
      } catch (error) {
        this.populateErrors(error);
      }
    },
  },
};
</script>
